import { addCryptography, removeCryptography } from "@/utils/cryptography";
import { formattedDateTime } from "@/utils/sessionsDateTime";

const userSessionPass = "@qG56W5w04YI";
const currentSessionPass = "9gX5#v@93%z1";
const guardSystemPass = "zE5m5w#Z9tFe";

// GET
export function getConnectedUser() {
  return removeCryptography("userSession", userSessionPass);
}

export function getCurrentSession() {
  return removeCryptography("currentSession", currentSessionPass);
}

export function getGuardSystem() {
  return removeCryptography("_guard", guardSystemPass);
}

export function getGuardSystemPass() {
  return guardSystemPass;
}

// SET
export function setConnectedUser(data) {
  addCryptography("userSession", JSON.stringify(data), userSessionPass);
}

export function setCurrentSession() {
  addCryptography(
    "currentSession",
    JSON.stringify(formattedDateTime()),
    currentSessionPass
  );
}

export function setGuardSystem() {
  addCryptography(
    "_guard",
    JSON.stringify({ key: guardSystemPass }),
    guardSystemPass
  );
}
